/**
 * @desc: 供应商查询
 * @created: 2020/4/13
 * @author:yeungyifan
 * @version : v1.0
 */
import request from '@/plugins/http'
import qs from 'qs'

// 列表
export const fetchSupplierList = params => {
  return request.get('/supplier/list/normal', params)
}

/**
 * @desc 查看详情
 * @params 列表row.id
 */
export const fetchDetails = params => {
  return request.get(`/supplier/${params}`, params)
}

/**
 * @desc 获取供应商终端
 * @params 列表row.supId
 */
export const fetchSupplierPosBySupId = params => {
  return request.get(`/supplier/listSupplierPos`, params)
}

// 修改受理终端状态
export const updatePosAndSim = data => {
  return request.post(`/supplier/updateOrAddPosAndSim`, data, { json: true })
}

// 解冻供应商
export const unfreeze = data => {
  return request.post('/supplier/unfreeze', qs.stringify(data))
}


// 冻结供应商
export const freeze = data => {
  return request.post('/supplier/freeze', qs.stringify(data))
}

// 转移归属
export const transferSupplierOwnership = data => {
  return request.post('/supplier/transferSupplierOwnership', data, { json: true })
}


// 获取人员归属情况
export const listSupplierOwnership = params => {
  return request.get('/supplier/listSupplierOwnership', params)
}

// 审批信息 
export const getSupApplyInfo = params => {
  return request.get('/supplier/getSupApplyInfo', params)
}

// 合同
export const getSupLookContract = params => {
  return request.get('/supplier/supLookContract', params)
}

// 供应商-签章
export const againSupContract = params => {
  return request.get('/supplier/againSupContract', params)
}

